import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { hapticError } from '@/utils/haptic';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationTimestamps = useRef([]);
  const cooldownActive = useRef(false);

  useEffect(() => {
    const now = Date.now();
    
    // Remove navigations older than 2 seconds
    navigationTimestamps.current = navigationTimestamps.current.filter(t => now - t < 2000);
    navigationTimestamps.current.push(now);
    
    // If too many navigations too fast, show warning
    if (navigationTimestamps.current.length >= 5 && !cooldownActive.current) {
      cooldownActive.current = true;
      hapticError();
      toast.warning("Slow down there partner! 🤠");
      
      setTimeout(() => {
        cooldownActive.current = false;
        navigationTimestamps.current = [];
      }, 1500);
    }
    
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
